module.exports = __webpack_public_path__ + "sideSprite-1b2e147dfb1bfdf8890f80ddf706a3b4.png";